module.exports = __webpack_public_path__ + "static/media/KimberleyEcho-devicecomp-min.8a0bfa77.png";